exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3IZkD-mhXR2UH14QFWSzKS ._444jUlOgNPF6nCkckTE_O{position:absolute;top:0;left:0}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "_3IZkD-mhXR2UH14QFWSzKS",
	"overlayWidgets": "_444jUlOgNPF6nCkckTE_O"
};